import type { QuickSetupFormState, SearchCategory } from './types';

export interface QuickSetupTemplate {
  id: string;
  label: string;
  name: string;
  patch: Partial<QuickSetupFormState>;
}

export const TEMPLATES: Record<SearchCategory, QuickSetupTemplate[]> = {
  vehicles: [
    {
      id: 'bmw-m3-e46',
      label: 'BMW M3 E46',
      name: 'BMW M3 E46',
      patch: {
        search_text: 'BMW M3 E46',
        brand: 'BMW',
        model: 'M3 E46',
      },
    },
    {
      id: 'bmw-2002',
      label: 'BMW 2002',
      name: 'BMW 2002',
      patch: {
        search_text: 'BMW 2002',
        brand: 'BMW',
        model: '2002',
      },
    },
    {
      id: 'honda-civic-type-r',
      label: 'Honda Civic Type R',
      name: 'Honda Civic Type R 2016',
      patch: {
        search_text: 'Honda Civic Type R',
        brand: 'Honda',
        model: 'Civic Type R',
        year_min: '2016',
        year_max: '2019',
      },
    },
  ],
  real_estate: [
    {
      id: 'apt-split',
      label: 'Apartment Split',
      name: 'Apartment Split',
      patch: {
        search_text: 'apartment',
        city: 'Split',
        region: 'Split-Dalmatia',
        property_type: 'apartment',
        rooms_min: '2',
      },
    },
    {
      id: 'apt-zagreb',
      label: 'Apartment Zagreb',
      name: 'Apartment Zagreb',
      patch: {
        search_text: 'apartment',
        city: 'Zagreb',
        region: 'City of Zagreb',
        property_type: 'apartment',
        rooms_min: '1',
      },
    },
    {
      id: 'house-dalmatia',
      label: 'House Dalmatia',
      name: 'House Dalmatia',
      patch: {
        search_text: 'house',
        region: 'Dalmatia',
        property_type: 'house',
        area_min: '80',
      },
    },
  ],
  jobs: [
    {
      id: 'angular-dev',
      label: 'Angular Developer',
      name: 'Angular Developer',
      patch: {
        keyword: 'Angular developer',
        location: 'Remote',
        remote_only: true,
      },
    },
    {
      id: 'python-dev',
      label: 'Python Developer',
      name: 'Python Developer',
      patch: {
        keyword: 'Python developer',
        location: 'Zagreb',
      },
    },
  ],
  marketplace: [
    {
      id: 'iphone',
      label: 'iPhone',
      name: 'iPhone listings',
      patch: {
        search_text: 'iPhone',
        condition: 'used',
      },
    },
    {
      id: 'playstation',
      label: 'PlayStation',
      name: 'PlayStation listings',
      patch: {
        search_text: 'PlayStation',
      },
    },
    {
      id: 'dji-drone',
      label: 'DJI Drone',
      name: 'DJI Drone',
      patch: {
        search_text: 'DJI drone',
        condition: 'used',
      },
    },
  ],
  custom: [],
};
